<template>
  <div>
    <Header />
    <div class="container">
      <div class="row-wrapper">
        <!-- <mdb-row class="justify-content-md-center"> -->
        <!-- <mdb-col>
            <Statistics
              :statistics="statistics"
              :affected="affectedCountriesCount"
              :recoveryRate="recoveryRate"
            />
        </mdb-col>-->
        <!-- <mdb-col> -->
        <Table
          :tableData="data"
          :statistics="statistics"
          :affected="affectedCountriesCount"
          :recoveryRate="recoveryRate"
          :label='"Africa COVID-19 Stats"'
        />
        <!-- </mdb-col>
        </mdb-row>-->
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "../layout/header";
import Footer from "../layout/footer.vue";
import Table from "./Table.vue";
// import Statistics from "./Statistics.vue";
import axios from "axios";

export default {
  name: "Wrapper",
  components: {
    Header,
    Footer,
    Table
    // Statistics
  },
  data() {
    return {
      statistics: [],
      tabuData: [],
      columns: [],
      rows: [],
      affectedCountriesCount: "",
      recoveryRate: "",
      timer: ""
    };
  },
  created() {
    this.fetchCountriesCOVIDData();
    this.timer = setInterval(this.fetchCountriesCOVIDData, 300000);
  },
  computed: {
    data() {
      return {
        columns: this.columns,
        rows: this.rows
      };
    }
  },
  methods: {
    filterData(dataArr, keys) {
      //   console.log(dataArr);
      let data = dataArr.map(entry => {
        let filteredEntry = {};
        keys.forEach(key => {
          if (key in entry) {
            filteredEntry[key] = entry[key];
          }
        });
        return filteredEntry;
      });
      return data;
    },
    fetchCountriesCOVIDData() {
      axios
        .get("https://ebidhaang-covidapi.herokuapp.com/api/africa")
        .then(json => {
          // console.log(json.data);

          let filteredData = json.data.splice(1);

          this.statistics = json.data[0];
          this.affectedCountriesCount = filteredData.length;

          let confirmed = json.data[0].confirmed.replace(/,/g, "");
          let recovered = json.data[0].recovered.replace(/,/g, "");

          let recoveredRate = (recovered / confirmed) * 100;
          this.recoveryRate = Math.ceil(recoveredRate);

          // console.log(this.statistics);

          let keys = [
            "id",
            "name",
            "confirmed",
            "deceased",
            "recovered",
            "serious"
          ];
          // this.rows = json.data
          let entries = this.filterData(filteredData, keys);
          // columns
          this.columns = keys.map(key => {
            return {
              label: key.toUpperCase(),
              field: key,
              sort: true
            };
          });
          // console.log("columns");
          // console.log(this.columns);
          // rows
          entries.map(entry => this.rows.push(entry));
        })
        .catch(err => console.log(err));
    }
  },
  mounted() {},
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>


<style scoped>
.row-wrapper {
  margin-top: 100px;
}
</style>